module.exports = __webpack_public_path__ + "static/media/shuffle.6c54c31c.png";